import { render, staticRenderFns } from "./examLoader.vue?vue&type=template&id=da2f1c7a"
import script from "./examLoader.vue?vue&type=script&lang=js"
export * from "./examLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports